import { move } from "@dnd-kit/helpers";
import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const newDashboard = {
  context: "",
  settings: {
    showSetup: true,
    refreshDelay: 1,
    filterByStatus: "all",
    groupByStatus: true,
    showAllUsers: true,
    showQueues: true, // TODO: default to false
  },
  userList: [],
  queueList: [],
};

const { actions, reducer } = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    // Setup
    createNewDashboard(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      if (!pbx) {
        state.push({
          ...newDashboard,
          context: action.payload.pbx,
        });
      }
    },
    resetDashboard(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.settings.showSetup = true;
      pbx.settings.refreshDelay = 1;
      pbx.settings.filterByStatus = "all";
      pbx.settings.groupByStatus = true;
      pbx.settings.showAllUsers = true;
      pbx.settings.showQueues = true;
      pbx.queueList = [];
      pbx.userList = [];

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    toggleShowSetup(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.settings.showSetup = !pbx.settings.showSetup;

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    // Settings
    setRefreshDelay(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.settings.refreshDelay = action.payload.refreshDelay;

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    setFilterByStatus(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.settings.filterByStatus = action.payload.status;

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    toggleGroupByStatus(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.settings.groupByStatus = !pbx.settings.groupByStatus;

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    toggleShowAllUsers(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.settings.showAllUsers = !pbx.settings.showAllUsers;

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    toggleShowQueues(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.settings.showQueues = !pbx.settings.showQueues;

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    // User list
    toggleDashboardUser(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      if (pbx.userList.find((_user) => _user === action.payload.userId)) {
        pbx.userList = pbx.userList.filter((_user) => _user !== action.payload.userId);
      } else {
        pbx.userList = [...pbx.userList, action.payload.userId];
      }

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    setDashboardUserList(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.userList = [...action.payload.list];

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    // Queue list
    toggleDashboardQueue(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      if (pbx.queueList.find((_queue) => _queue.id === action.payload.queueId)) {
        pbx.queueList = pbx.queueList.filter((_queue) => _queue.id !== action.payload.queueId);
      } else {
        pbx.queueList = [...pbx.queueList, { id: action.payload.queueId, expanded: false }];
      }

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    deleteDashboardQueue(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.queueList = pbx.queueList.filter((_queue) => _queue.id !== action.payload.queueId);

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    setDashboardQueueList(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      action.payload.list.map((queue) => {
        if (pbx.queueList.find((_queue) => _queue.id === queue)) {
          return;
        }

        pbx.queueList.push({ id: queue, expanded: false });
      });

      // We only allow up to 20 queues on the dashboard
      pbx.queueList = pbx.queueList.slice(0, 20);

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    updateDashboardQueueOrder(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.queueList = move(pbx.queueList, action.payload.dndEvent);

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    clearDashboardQueueList(state, action) {
      // Queue has a separate clear function because the list function is cumulative rather than replacing all contents
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.queueList = [];

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
    toggleQueueExpandState(state, action) {
      const pbx = state.find((_pbx) => _pbx.context === action.payload.pbx);

      pbx.queueList = pbx.queueList.map((queue) => {
        if (queue.id === action.payload.queueId) {
          queue.expanded = !queue.expanded;
        }

        return queue;
      });

      state.map((_pbx) => {
        if (_pbx.context === pbx.context) {
          return pbx;
        }

        return _pbx;
      });
    },
  },
});

export const {
  resetDashboard,
  createNewDashboard,
  toggleShowSetup,
  setRefreshDelay,
  setFilterByStatus,
  toggleGroupByStatus,
  toggleShowAllUsers,
  toggleShowQueues,
  toggleDashboardUser,
  setDashboardUserList,
  toggleDashboardQueue,
  deleteDashboardQueue,
  setDashboardQueueList,
  updateDashboardQueueOrder,
  clearDashboardQueueList,
  toggleQueueExpandState,
} = actions;

export default reducer;
